export default {
  salesBill: {
    table: {
      currencyName: '币种',
      tradeTypeName: '贸易类型',
      customerName: '客户名称',
      ladingNo: '提单号',
      contractNo: '销售合同编号',
      ladingCreateDate: '制单日期',
      deliveryDate: '发货日期',
      ladingBusinessCompanyName: '公司',
      ladingBusinessDepartmentName: '业务部门',
      isCreditsale: '是否赊销',
      lastestReceiveMoneyDay: '最晚收款日',
      storageName: '仓库',
      ladingTotalQuantity: '提单总数量',
      ladingQuantity: '提单数量',
      businessChangingUnitPrice: '变动单价',
      accountingStatus: '入账状态',
      ladingStatus: '提单状态',
      businessLadingTotalAmount: '销售总金额',
      actualSendQuantity: '实发数量',
      actualSendAmount: '实发金额',
      businessOrderNo: '业务订单号',
      supplychainName: '供应链主体',
      settleBatchNoForShow: '结算批次',
      deliveryMethod: '交货方式',
      shippingMethod: '运输方式',
      ladingSalesmanName: '业务员',
      nonInvoiceQuantity: '未开票总数量',
      ladingOperatorName: '操作人',
      baseName: '基地简称',
      platformCompanyName: '平台公司名称',
      carNo: '车牌号',
      netWeight: '净重',
      deduct: '扣杂',
      shipComplete: '是否完全发货',
      businessInboundBatchNo: '业务入库批次',
      productDesc: '商品描述',
      mark: '备注',
      relationLadingFlag: '是否有关联提单',
      relationLadingNo: '关联提单号',
    },
    search: {
      ladingNo: '提单号',
      ladingNoPlaceholder: '筛选多条时单号以逗号（,）分隔',
      startGmtCreate: '制单开始日期',
      endGmtCreate: '制单结束日期',
      storageNo: '仓库',
      deliveryMethod: '交货方式',
      // contractNo: '意向单号',
      startLadingCreateDate: '开单开始日期',
      endLadingCreateDate: '开单结束日期',
      receivingUnit: '收货单位',
      contractNo: '销售合同编号',
      intentionNo: '意向单号',
      externalContractNo: '外部合同号',
      billTotalAmount: '销售总金额',
      customerNo: '客户',
      ladingStatus: '提单状态',
      ladingStatusPlaceholder: '请选择提单状态',
      settleBatchNo: '结算批次号',
      billTotalQuantity: '提单数量',
      supplierNo: '供应商',
      shippingMethod: '运输方式',
      lastestReceiveMoneyDay: '最晚收款日',
      ladingBusinessDepartmentNo: '业务部门',
      ladingSalesmanNo: '业务员',
      isCreditsale: '赊销',
      deliveryDate: '发货日期',
      nonInvoiceQuantity: '未开票总数量',
      gt: '大于',
      lt: '小于',
      notEqual: '不等于',
      equal: '等于',
      yes: '是',
      no: '否',
      ladingOperatorName: '操作人',
      ladingCreateDate: '开单日期',
      shipComplete: '是否完全发货',
      businessInboundBatchNo: '业务入库批次',
      productDesc: '商品描述',
      supplychainName: '供应链主体',
      identifyingCode: '商品识别码',
      identifyingCodePlaceholder: '请输入商品识别码',
      relationLadingFlag: '是否有关联提单',
      relationLadingNo: '关联提单号',
      relationLadingNoPlaceholder: '请输入关联提单号',
    },
    message: {
      justOneCopy: '只能选择一条数据进行复制',
      noDataExported: '当前无数据可以导出',
      justOneGenerate: '只能选择一条数据生成运输单',
      unableToGenerate: '请检查提单状态，无法生成运输单',
      generateSuccess: '生成成功',
      addSale: '销售提单创建',
      editSale: '销售提单编辑',
      makeOutInvoice: '销售开票',
      justOneInvoice: '只能选择一条数据单独开票',
      justOneDiffInvoice: '只能选择一条数据差额开票',
      lessTwoInvoice: '至少选择两条数据合并开票',
      lessOneInvoice: '至少选择一条数据开票',
      onlyApprovalSeparatelyAlone: '只能选择已确认的数据才能开票',
      onlyApprovalSeparately: '只能选择已确认的数据合并开票',
      onlyTotalGreaterSeparately: '只能选择未开票总数量大于0的数据单独开票',
      onlyTotalGreaterSeparatelyDiffInvoice: '请选择单独开票或合并开票',
      justOnceThawManually: '请选择一条数据冻结',
      justOnceManuallyFreeze: '请选择一条数据解冻',
      onlyApprovalThawManually: '只能选择已确认的数据冻结',
      onlyApprovalManuallyFreeze: '只能选择已冻结的数据解冻',
      reselect: '不符合合并规则，请重新选择',
      chooseData: '请选择一条数据',
      onlyDeleted: '只有已保存和已撤回状态可以删除',
      quantityInsufficient: '可提数量不足',
      notSelectedBillLading: '未选择商品进行提单',
      quantityCannotZero: '提单数量不能为零',
      goodNotSortingMatching: '所有商品未全部拣配，请继续拣配',
      makeSuccess: '操作成功',
      searchSale: '销售提单查询',
      cancelledDelete: '已取消删除',
      delSuccess: '删除成功',
      selectOneMatching: '请选择一条行项目进行拣配',
      goodsDetailMatched: '提单数量大于零的商品明细才可以拣配',
      dueChangeMatching: '由于拣配数量发生变化，将清除该条数据的拣配结果',
      emptyPicking: '是否确认清空拣配结果？',
      businessMatching: '业务入库批次拣配',
      confirm: '确定',
      cancel: '取消',
      quantityMatch: '待拣配数量不为零请继续拣配',
      createSales: '创建销售提单',
      selectGoods: '请选择同一个合同的商品创建提单',
      createSalesGoods: '请选择创建提单的商品',
      notSelectedDelete: '您还没选择想要删除的数据',
      currentlyLimited: '当前限制选择 3 个文件，本次选择了',
      file: '个文件',
      allChooseFile: '个文件，共选择了',
      sureRemove: '确定移除',
      questionMark: '？',
      transTip: '该销售提单已生成物流运输单，请选择其他单号',
      businessChangingUnitPriceMsg: '请选择变动单价',
      sureInvoiceMsg: '请确认实发数量，将按照该数量进行开票，且一旦开票物流无法再发货',
      diffStorageAndDeliver: '选中的项目仓库和交货方式不一致',
      carNoMsg: '车牌号必填',
      netWeightMsg: '净重必填',
      deductMsg: '扣杂必填',
    },
    tab: {
      productDetail: '商品明细',
      pickingTab: '批次拣配结果',
      logisticsInfo: '物流信息',
    },
    title: {
      uploadFile: '上传附件',
    },
    button: {
      save: '保存',
      submit: '提交',
      creatTransportBill: '生成运输单',
      deteleBill: '删除',
    },
    baseInfo: {
      label: {
        ladingCreateDate: '制单日期',
        ladingNo: '提单号',
        ladingCurrency: '货币',
        exchangeRate: '汇率',
        ladingBusinessDepartmentName: '业务部门',
        ladingSalesmanName: '业务员',
        ladingOperatorName: '操作人',
        customerName: '客户',
        supplierName: '供应商',
        contractDetailCategory: '订单类型',
        businessType: '经营方式',
        storageNo: '仓库',
        deliveryDate: '发货日期',
        deliveryMethod: '交货方式',
        shippingMethod: '运输方式',
        ladingTotalQuantity: '提单总数量',
        businessLadingTotalAmount: '提单总金额',
        businessLadingTotalAmountOther: '提单总金额(本币)',
        receivingUnit: '收货单位',
        deliveryAddress: '交货地址',
        isCreditsale: '是否赊销',
        lastestReceiveMoneyDay: '最晚收款日期',
        contractNo: '合同号',
        externalContractNo: '外部合同号',
        tradeTypeName: '贸易类型',
        nonInvoiceQuantity: '未开票总数量',
        returnStatusName: '状态',
        pleaseChoose: '请选择',
        pleaseChooseWrite: '请输入',
        outstandingAmount: '未发货金额',
        amountDelivered: '已发货金额',
        ladingBusinessCompanyCode: '业务公司编码',
        ladingBusinessCompanyName: ' 业务公司名称',
        companyCurrencyCode: '本位币币种',
        relationLadingBusinessCompanyCodePlaceholder: '请选择关联提单的业务公司',
        baseNamePlaceholder: '请选择基地简称',
        platformCompanyNamePlaceholder: '请选择平台公司名称',
      },
    },
    batchMatchingResults: {
      button: {
        batchPicking: '拣配',
        emptyPicking: '清空拣配',
        del: '删除',
      },
      table: {
        seq: '序号',
        contractDetailNo: '合同行项目号',
        delete: '删除',
        cancelDelete: '撤销删除',
        action: '操作',
        groupCategoryName: '商品大类',
        productNo: '商品编码',
        detailProductModel: '商品规格',
        availableQuantity: '可提数量',
        availableQuantityHN: '剩余可提数量',
        ladingUnitNameHN: '计量单位',
        purchaseBusinessUnitPrice: '采购单价',
        proxyBusinessUnitPrice: '销售单价',
        purchaseBusinessTotalAmount: '采购金额',
        proxyBusinessTotalAmount: '销售金额',
        salesQuantity: '合同数量',
        ladingQuantity: '提单数量',
        invoiceDate: '实发数量',
        businessChangingUnitPrice: '变动单价',
        businessContractUnitPriceHN: '提单单价',
        businessLadingAmount: '提单金额',
        businessDeliveryExpenseUnitPrice: '运费单价',
        invoiceQuantity: '已开票数量',
        nonInvoiceQuantity: '未开票数量',

        ladingDetailNo: '提单行项目号',
        productDesc: '商品描述',
        ladingUnitName: '单位',
        supplier: '供应商',
        businessContractUnitPrice: '合同单价',
        pickingQuantity: '拣配数量',
        businessPickingAmount: '拣配金额',
        businessInboundBatchNo: '业务入库批次号',
        carNo: '车牌号',
        netWeight: '净重',
        deduct: '扣杂',
        settleBatchNo: '结算批次号',
        distributionBatchNo: '物流批次',
        customerReceiveQuantity: '客户实收数量',
        currencyName: '币种',
        invoiceAmount: '已开票金额',
        invoiceCode: '销售发票单据编号',
      },
      title: {
        result: '拣配结果',
      },
    },
    creatDialog: {
      title: {
        searchOrderProductDetail: '查询订单商品明细',
      },
      search: {
        productNo: '商品描述',
        contractNo: '销售合同编号',
        contractBusinessDepartment: '部门',
        customerNo: '客户',
        storageNo: '仓库',
        supplierNo: '供应商',
      },
      table: {
        contractNo: '销售合同编号',
        externalContractNo: '外部合同号',
        contractDetailNo: '合同行项目号',
        contractBusinessDepartmentName: '部门',
        storageName: '仓库',
        deliverTypeName: '交货方式',
        productDesc: '商品描述',
        unitName: '单位',
        productQuantity: '销售数量',
        availableLadingQuantity: '可提数量',
        customerName: '客户',
        supplierName: '供应商',
        contractStatusName: '订单状态',
        lastestReceiveMoneyDay: '最晚收款日期',
        isCreditsale: '是否赊销',
        lastestSendProductDay: '最晚发货日期',
      },
    },
    logisticsInfo: {
      label: {
        storageExpenseTaker: '仓储费承担',
        other: '其他',
        outboundExpenseTaker: '出库费/货转费承担',
        deliveryExpenseTaker: '运费承担',
        storageExpenseEndDate: '仓储费承担截止日期',
        businessOutboundExpenseAmount: '出库费/货转费金额',
        businessDeliveryExpenseAmount: '运费总金额',
        businessStorageExpenseAmount: '仓储费金额',
        supplierNo: '供应商',
        receiver: '收货人',
        receiverPhone: '收货联系电话',
        require: '要求送达时间',
      },
      button: {
        add: '新增',
        del: '删除',
      },
      table: {
        seq: '序号',
        productDetailNo: '提单行项目号',
        productDesc: '商品描述',
        marineLadingNo: '海运提单号',
        warehouseReceiptsNo: '仓单号',
        nameVoyageLicense: '船名/航次/车牌/承运方',
        driverName: '驾驶员姓名',
        contactPhoneNo: '联系电话',
        identityCardNo: '身份证号',
        mark: '备注',
      },
    },
    productDetails: {
      label: {
        businessLadingTotalAmount: '提单总金额',
        ladingTotalQuantity: '提单总数量',
      },
    },
    batchPickingDialog: {
      search: {
        ladingBusinessDepartmentName: '部门',
        storageName: '仓库',
        productDesc: '商品描述',
        startGmtCreate: '入库日期起',
        endGmtCreate: '入库日期止',
        contractInternalNo: '采购合同号',
        batchNo: '入库批次号',
        inboundNo: '业务入库单号',
        partnerName: '供应商名称',
        marineLadingNo: '海运提单号',
        warehouseReceiptsNo: '仓单号',
        settleBatchNo: '结算批次',
        storageBatch: '船名航次',
        orderNo: '业务订单',
        supplychainName: '供应链主体',
        identifyingCode: '商品识别码',
      },
      table: {
        batchNo: '入库批次号',
        storageQuantity: '库存数量',
        orderNo: '业务订单',
        availableSaleQuantityChange: '可售数量',
        pickingQuantity: '拣配数量',
        storageName: '仓库',
        productName: '商品描述',
        inboundDate: '入库日期',
        gmtCreate: '创建日期',
        inboundNo: '单据号',
        contractInternalNo: '采购合同编号',
        businessUnitPriceWithTax: '入库单价',
        financeUnitPriceWithTax: '发票单价',
        partnerName: '供应商名称',
        marineLadingNo: '海运提单号',
        warehouseReceiptsNo: '仓单号',
        settleBatchNo: '结算批次号',
        supplychainName: '供应链主体',
        identifyingCode: '商品识别码',
      },
      text: {
        toPickNumber: '待拣配数量：',
        hasPickNumber: '已拣配数量：',
      },
    },
  },
};
